<!-- List screen (FeesInformation.js) -->
<div class="pf-wrap" *ngIf="!selectedCard">
  <div class="pf-page-head">
    <h1 class="pf-page-title">{{ 'fees' | translate }}</h1>
  </div>

  <div class="pf-error" *ngIf="error">{{ error }}</div>

  <!-- Full-width summary card, stacked above the list -->
  <div class="pf-hero-card" *ngIf="!loading">
    <div class="pf-hero-label">{{ 'dueNow' | translate }}</div>
    <div class="pf-hero-amount">{{ currencySymbol }}{{ dueNowTotal | number }}</div>

    <div class="pf-hero-overdue-note" *ngIf="hasOverdue && earliestOverdueCard">
      <i class="ri-error-warning-line"></i>
      {{ currencySymbol }}{{ overdueTotal | number }} {{ 'overdueSince' | translate }} {{ earliestOverdueCard.dueDate | date: 'd MMM' }}
    </div>

    <div class="pf-hero-divider"></div>

    <div class="pf-hero-paid-row">
      <span class="pf-hero-paid-label">{{ 'paidThisYear' | translate }}</span>
      <span class="pf-hero-paid-percent">{{ paidPercent }}% {{ 'paid' | translate }}</span>
    </div>
    <div class="pf-hero-paid-amount">{{ currencySymbol }}{{ totalPaidAmount | number }} {{ 'ofAmount' | translate }} {{ currencySymbol }}{{ (totalPaidAmount + totalBalance) | number }}</div>

    <div class="pf-progress-track">
      <div class="pf-progress-fill" [style.width.%]="paidPercent"></div>
    </div>
  </div>

  <div class="pf-body" *ngIf="!loading; else pfLoading">
    <div class="pf-list-col" [class.pf-list-pending]="balanceCheckPending" [class.pf-list-with-floating-bar]="hasSelection">
      <div class="pf-empty" *ngIf="!cards.length && !otherFees.length && !error">
        <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
        <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
      </div>

      <ng-container *ngIf="dueNowCards.length">
        <div class="pf-section-head">
          <h4 class="pf-section-title">{{ 'dueNow' | translate }}</h4>
          <span class="pf-section-hint">{{ 'tickFeesToPay' | translate }}</span>
        </div>

        <div class="pf-card" [ngClass]="cardAccentClass(card)" *ngFor="let card of dueNowCards" (click)="openDetail(card)">
          <button type="button" class="pf-checkbox" *ngIf="showCheckbox(card)" [class.selected]="isSelected(card, isOtherFee(card))"
            (click)="$event.stopPropagation(); toggleSelection(card, isOtherFee(card))">
            <i class="ri-check-line" *ngIf="isSelected(card, isOtherFee(card))"></i>
          </button>
          <div class="pf-checkbox-spacer" *ngIf="!showCheckbox(card)"></div>

          <div class="pf-card-body">
            <div class="pf-card-top">
              <div class="pf-card-name">{{ card.name }}</div>
              <div class="pf-card-amount-top">{{ currencySymbol }}{{ card.balance + (card.lateFee > 0 ? card.lateFee : 0) | number }}</div>
            </div>

            <div class="pf-card-tags">
              <span class="pf-chip" [ngClass]="statusChipClass(card)">{{ statusLabel(card) | translate }}</span>
              <span class="pf-card-due-text" *ngIf="card.dueDate">
                {{ duePrefixKey(card) | translate }} {{ card.dueDate | date: 'd MMM y' }},
                {{ dueSuffixKey(card) | translate:{ days: dueInDaysCount(card) } }}
              </span>
            </div>

            <div class="pf-card-breakdown" *ngIf="hasLateFeeBreakdown(card)">
              {{ 'feeAndLateFeeBreakdown' | translate:{ fee: currencySymbol + card.balance, lateFee: currencySymbol + card.lateFee } }}
            </div>

            <span class="pf-cooldown-tag" *ngIf="card.timeLeftToPayAgain"><i class="ri-time-line"></i> {{ 'payAgainIn' | translate }} {{ card.timeLeftToPayAgain }}</span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="comingUpCards.length">
        <div class="pf-section-head">
          <h4 class="pf-section-title">{{ 'comingUp' | translate }}</h4>
          <span class="pf-section-hint">{{ 'canPayTheseEarly' | translate }}</span>
        </div>

        <div class="pf-card" [ngClass]="cardAccentClass(card)" *ngFor="let card of comingUpCards" (click)="openDetail(card)">
          <button type="button" class="pf-checkbox" *ngIf="showCheckbox(card)" [class.selected]="isSelected(card, isOtherFee(card))"
            (click)="$event.stopPropagation(); toggleSelection(card, isOtherFee(card))">
            <i class="ri-check-line" *ngIf="isSelected(card, isOtherFee(card))"></i>
          </button>
          <div class="pf-checkbox-spacer" *ngIf="!showCheckbox(card)"></div>

          <div class="pf-card-body">
            <div class="pf-card-top">
              <div class="pf-card-name">{{ card.name }}</div>
              <div class="pf-card-amount-top">{{ currencySymbol }}{{ card.balance | number }}</div>
            </div>

            <div class="pf-card-tags">
              <span class="pf-card-due-text" *ngIf="card.dueDate">{{ 'dueDate' | translate }} {{ card.dueDate | date: 'd MMM y' }}</span>
            </div>

            <div class="pf-card-breakdown" *ngIf="hasLateFeeBreakdown(card)">
              {{ 'feeAndLateFeeBreakdown' | translate:{ fee: currencySymbol + card.balance, lateFee: currencySymbol + card.lateFee } }}
            </div>

            <span class="pf-cooldown-tag" *ngIf="card.timeLeftToPayAgain"><i class="ri-time-line"></i> {{ 'payAgainIn' | translate }} {{ card.timeLeftToPayAgain }}</span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="paidCards.length">
        <div class="pf-section-head">
          <h4 class="pf-section-title">{{ 'paidThisYear' | translate }}</h4>
        </div>

        <div class="pf-paid-list">
          <div class="pf-paid-row" *ngFor="let card of paidCards" (click)="openDetail(card)">
            <span class="pf-paid-check"><i class="ri-check-line"></i></span>
            <div class="pf-paid-text">
              <div class="pf-paid-name">{{ card.name }}</div>
              <div class="pf-paid-meta" *ngIf="card.dueDate">{{ 'paid' | translate }} {{ card.dueDate | date: 'd MMM y' }}</div>
            </div>
            <div class="pf-paid-amount">{{ currencySymbol }}{{ card.amount | number }}</div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <ng-template #pfLoading>
    <div class="pf-body">
      <div class="pf-list-col">
        <div class="pf-card pf-card-skeleton" *ngFor="let n of [1,2,3]"></div>
      </div>
    </div>
  </ng-template>

  <!-- Sticky bottom Pay bar — appears only when something's selected -->
  <div class="pf-sticky-pay-bar" *ngIf="hasSelection">
    <div class="pf-sticky-pay-total">
      <span>{{ selectedCount }} {{ (selectedCount === 1 ? 'feeSelected' : 'feesSelected') | translate }}</span>
      <strong>{{ currencySymbol }}{{ totalSelectedAmount | number }}</strong>
    </div>
    <button type="button" class="pf-sticky-pay-btn" (click)="payTotal()"><i class="ri-bank-card-line"></i> {{ 'payNow' | translate }}</button>
  </div>
</div>

<!-- Detail screen (FeesDetailedView.js + Timeline.js) -->
<div class="pf-detail-wrap" *ngIf="selectedCard as card">
  <header class="pf-detail-header">
    <button type="button" class="pf-detail-back" (click)="closeDetail()"><i class="ri-arrow-left-line"></i></button>
    <div class="pf-detail-header-text">
      <div class="pf-detail-header-eyebrow">{{ 'feesDetail' | translate }}</div>
      <div class="pf-detail-header-subtitle">{{ studentName }}</div>
    </div>
  </header>

  <div class="pf-detail-title-row">
    <h2 class="pf-detail-fee-name">{{ card.name }}</h2>
    <span class="pf-chip" [ngClass]="statusChipClass(card)">{{ statusLabel(card) | translate }}</span>
  </div>

  <div class="pf-detail-card">
    <div class="pf-summary-row">
      <span class="pf-summary-label">{{ 'balanceFees' | translate }}</span>
      <span class="pf-summary-value">{{ currencySymbol }}{{ card.balance | number }}</span>
    </div>
    <div class="pf-summary-row">
      <span class="pf-summary-label">{{ 'total' | translate }}</span>
      <span class="pf-summary-value">{{ currencySymbol }}{{ card.amount | number }}</span>
    </div>
    <div class="pf-summary-row">
      <span class="pf-summary-label">{{ 'discount' | translate }}</span>
      <span class="pf-summary-value">{{ currencySymbol }}{{ card.discount | number }}</span>
    </div>
    <div class="pf-summary-row" *ngIf="card.lateFee">
      <span class="pf-summary-label">{{ 'lateFee' | translate }}</span>
      <span class="pf-summary-value">{{ currencySymbol }}{{ card.lateFee | number }}</span>
    </div>
    <div class="pf-summary-row pf-summary-row-last">
      <span class="pf-summary-label">{{ 'totalPaid' | translate }}</span>
      <span class="pf-summary-value pf-summary-value-green">{{ currencySymbol }}{{ card.paid | number }}</span>
    </div>
  </div>

  <button type="button" class="pf-pay-btn" *ngIf="card.balance > 0 && onlinePaymentEnabled" [disabled]="!!card.timeLeftToPayAgain" (click)="payFromDetail(card)">
    {{ 'payNow' | translate }} {{ currencySymbol }}{{ (card.lateFee > 0 ? card.balance + card.lateFee : card.balance) | number }}
  </button>
  <p class="pf-detail-error" *ngIf="card.balance > 0 && !canPayFromDetail(card)">{{ 'payOlderFeesFirstMessage' | translate }}</p>
  <p class="pf-detail-cooldown" *ngIf="card.balance > 0 && card.timeLeftToPayAgain"><i class="ri-time-line"></i> {{ 'tryAgainIn' | translate }} {{ card.timeLeftToPayAgain }}</p>

  <h4 class="pf-timeline-title">{{ 'paymentBreakUp' | translate }}</h4>

  <div class="pf-detail-loading" *ngIf="detailLoading"><i class="ri-loader-4-line pf-spin"></i></div>
  <div class="pf-detail-error" *ngIf="detailError">{{ detailError }}</div>
  <div class="pf-timeline-empty" *ngIf="!detailLoading && !detailError && !history.length">{{ 'dataNotFound' | translate }}</div>

  <div class="pf-timeline">
    <div class="pf-timeline-row" *ngFor="let entry of history">
      <span class="pf-timeline-dot"></span>
      <div class="pf-timeline-content">
        <div class="pf-timeline-field">
          <span class="pf-timeline-field-label">{{ 'receiptNumber' | translate }}</span>
          <span class="pf-timeline-field-value">{{ entry.ReceiptNumber }}</span>
        </div>
        <div class="pf-timeline-field">
          <span class="pf-timeline-field-label">{{ 'paymentMode' | translate }}</span>
          <span class="pf-timeline-field-value">{{ entry.ModeOfPayment }}</span>
        </div>
        <div class="pf-timeline-field">
          <span class="pf-timeline-field-label">{{ 'paidAmount' | translate }}</span>
          <span class="pf-timeline-field-value pf-timeline-field-value-green">{{ currencySymbol }}{{ entry.totalAmount | number }}</span>
        </div>
        <div class="pf-timeline-field">
          <span class="pf-timeline-field-label">{{ 'paidOn' | translate }}</span>
          <span class="pf-timeline-field-value">{{ entry.CreatedDate | date: 'dd-MMM-y' }}</span>
        </div>
        <button type="button" class="pf-view-receipt-btn" [disabled]="receiptLoading" (click)="viewReceipt(entry)">
          {{ (receiptLoading ? 'pleaseWait' : 'viewReceipt') | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- In-app receipt preview — built as a real template, not a fetched
     PDF/URL: generateFeeReceipt returns structured row data (one row per
     fee line-item paid), which the mobile app turns into an HTML receipt
     on-device. "Print" uses the browser's native print-to-PDF, since
     neither react-native-html-to-pdf nor its native share sheet has a web
     equivalent. -->
<div class="pf-viewer-overlay" *ngIf="receiptRows as rows" (click)="closeReceiptViewer()">
  <div class="pf-receipt-window" (click)="$event.stopPropagation()">
    <div class="pf-receipt-toolbar">
      <button type="button" class="pf-viewer-close" (click)="closeReceiptViewer()"><i class="ri-close-line"></i></button>
      <div class="pf-receipt-toolbar-actions">
        <button type="button" class="pf-print-btn" (click)="printReceipt()">
          <i class="ri-printer-line"></i> {{ 'print' | translate }}
        </button>
      </div>
    </div>

    <!-- Same layout as the admin fee receipt (feesmanage view-receipt). -->
    <div class="pf-receipt-paper" #receiptPaper *ngIf="rows.length">
      <div class="pf-ar-head">
        <img *ngIf="rows[0].schoolImage" [src]="rows[0].schoolImage" class="pf-ar-logo" alt="" />
        <h3 class="pf-ar-school">{{ rows[0].schoolName }}</h3>
        <p class="pf-ar-address" *ngIf="rows[0].address">{{ rows[0].address }}</p>
      </div>
      <div class="pf-ar-title">{{ 'feeReceipt' | translate }}</div>

      <div class="pf-ar-meta">
        <div class="pf-ar-col">
          <div>{{ 'receiptNo' | translate }} <b>{{ rows[0].ReceiptNumber }}</b></div>
          <div>{{ 'name' | translate }} <b>{{ rows[0].studentName }}</b></div>
          <div>{{ 'parentName' | translate }} : <b>{{ rows[0].parentName }}</b></div>
          <div>{{ 'class' | translate }} : <b>{{ rows[0].classNumber }} - {{ rows[0].classDivision }}</b></div>
        </div>
        <div class="pf-ar-col">
          <div>{{ 'date' | translate }} <b>{{ rows[0].CreatedDate | date: 'dd-MMM-yyyy' }}</b></div>
          <div *ngIf="rows[0].registrationId">{{ 'admissionNo' | translate }} <b>{{ rows[0].registrationId }}</b></div>
          <div>{{ 'transactionId' | translate }} <b>{{ rows[0].paymentId || ('na' | translate) }}</b></div>
          <div>{{ 'modOfPayment' | translate }} <b>{{ rows[0].ModeOfPayment === 'Card&Cash' ? 'Card & Cash' : rows[0].ModeOfPayment }}</b></div>
        </div>
      </div>

      <table class="pf-ar-table">
        <thead>
          <tr>
            <th class="pf-ar-left">{{ 'fee' | translate }}({{ rows[0].currencyType }})</th>
            <th>{{ 'feeAmt' | translate }}({{ rows[0].currencyType }})</th>
            <th>{{ 'disAmt' | translate }}({{ rows[0].currencyType }})</th>
            <th>{{ 'paidAmt' | translate }}({{ rows[0].currencyType }})</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td class="pf-ar-left">{{ row.TermName || row.name }}</td>
            <td>{{ row.ActualAmount }}</td>
            <td>{{ row.DiscountAmount || 0 }}</td>
            <td>{{ row.Amount }}</td>
          </tr>
          <tr class="pf-ar-line">
            <td class="pf-ar-left">{{ 'totalAmount' | translate }}</td>
            <td>{{ receiptTotalActual }}</td>
            <td>{{ receiptTotalDiscount }}</td>
            <td>{{ receiptTotalPaid }}</td>
          </tr>
          <tr class="pf-ar-plain">
            <td class="pf-ar-left">{{ 'lateFeeAmount' | translate }}</td>
            <td></td><td></td>
            <td class="pf-ar-underline">{{ receiptTotalLateFee }}</td>
          </tr>
          <tr class="pf-ar-plain">
            <td class="pf-ar-left">{{ 'netAmount' | translate }}</td>
            <td></td><td></td>
            <td class="pf-ar-underline">{{ receiptNetAmount }}</td>
          </tr>
          <tr class="pf-ar-plain">
            <td class="pf-ar-left">{{ 'receivedAmount' | translate }}({{ rows[0].ModeOfPayment === 'Card&Cash' ? 'Card & Cash' : rows[0].ModeOfPayment }})</td>
            <td></td><td></td>
            <td>{{ receiptTotalPaid }}</td>
          </tr>
          <tr class="pf-ar-plain">
            <td class="pf-ar-left">{{ 'totalReceivedAmount' | translate }}</td>
            <td></td><td></td>
            <td class="pf-ar-line-cell">{{ receiptTotalReceived }}</td>
          </tr>
        </tbody>
      </table>

      <div class="pf-ar-words" *ngIf="receiptAmountInWords"><b>{{ 'amountInWords' | translate }}:</b> {{ receiptAmountInWords }}</div>
      <div class="pf-ar-foot">
        <span>{{ 'systemGeneratedReceiptNote' | translate }}</span>
        <span class="pf-ar-sign">{{ 'authorizedSignatory' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Old academic year dues gate (FeesInformation.js's itemCheckBalanceAmount) -->
<div class="pf-modal-overlay" *ngIf="oldDuesBlocked" (click)="dismissOldDuesNotice()">
  <div class="pf-modal" (click)="$event.stopPropagation()">
    <h3 class="pf-modal-title">{{ 'balance' | translate }}</h3>
    <p class="pf-modal-text">{{ 'oldDuesPendingMessage' | translate }}</p>
    <button type="button" class="pf-modal-close-btn" (click)="dismissOldDuesNotice()">{{ 'close' | translate }}</button>
  </div>
</div>

<!-- Payment initiation (PaymentDetails.js) — cards holds every fee being
     paid together (one item from the detail screen's Pay button, or
     several from the sticky Pay bar's multi-select). -->
<app-parent-fees-payment *ngIf="paymentCards as pcs" [cards]="pcs" [studentId]="studentId" [classId]="classId"
  [academicId]="academicId" [studentName]="studentName" (closed)="closePayment()" (paid)="onPaid($event)">
</app-parent-fees-payment>
